import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/Home.vue')
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('@/views/About.vue')
  },
  {
    path: '/products',
    name: 'Products',
    component: () => import('@/views/Products.vue'),
    children: [
      {
        path: 'system-series',
        name: 'SystemSeries',
        component: () => import('@/views/products/SystemSeries.vue')
      },
      {
        path: 'modem-series',
        name: 'ModemSeries',
        component: () => import('@/views/products/ModemSeries.vue')
      },
      {
        path: 'station-series',
        name: 'StationSeries',
        component: () => import('@/views/products/StationSeries.vue')
      }
    ]
  },
  {
    path: '/products/:category/:id',
    name: 'ProductDetail',
    component: () => import('@/views/products/ProductDetail.vue')
  },
  {
    path: '/cases',
    name: 'Cases',
    component: () => import('@/views/Cases.vue')
  },
  {
    path: '/news',
    name: 'News',
    component: () => import('@/views/News.vue')
  },
  {
    path: '/news/:id',
    name: 'NewsItem',
    component: () => import('@/views/NewsItem.vue')
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import('@/views/Contact.vue')
  },
  {
    path: '*',
    redirect: '/'
  }
]

// 解决方案1：改为hash模式（推荐，无需服务器配置）
const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
  // 添加滚动行为，确保路由跳转时滚动条置顶
  scrollBehavior(to, from, savedPosition) {
    // 如果有保存的位置（如使用浏览器前进/后退按钮），则恢复到该位置
    if (savedPosition) {
      return savedPosition
    } else {
      // 否则滚动到顶部
      return { x: 0, y: 0 }
    }
  }
})

// 解决方案2：保持history模式，但需要配置服务器将所有请求重定向到index.html
// 以下是常见服务器的配置示例：

/*
// Nginx配置示例
server {
  listen 80;
  server_name example.com;
  root /path/to/dist;
  
  location / {
    try_files $uri $uri/ /index.html;
  }
}

// Apache配置示例 (.htaccess文件)
<IfModule mod_rewrite.c>
  RewriteEngine On
  RewriteBase /
  RewriteRule ^index\.html$ - [L]
  RewriteCond %{REQUEST_FILENAME} !-f
  RewriteCond %{REQUEST_FILENAME} !-d
  RewriteRule . /index.html [L]
</IfModule>

// Caddy配置示例
example.com {
  root * /path/to/dist
  try_files {path} {path}/ /index.html
  file_server
}
*/

export default router








